import React from 'react'
import cl from 'classnames'

import { NotificationType } from 'Core/interfaces'

import { Icon } from '..'
import { IconType } from '../Icon'

import styles from './styles.module.scss'

interface Props {
	condition?: boolean
	text: string | React.ReactNode
	type: NotificationType
	className?: string
	iconType?: IconType
}

const ModalNotification: React.FC<Props> = ({
	condition = true,
	text,
	type,
	className,
	iconType
}) =>
	condition ? (
		<div className={cl(className, styles[type])}>
			{iconType && <Icon type={iconType} />}
			{text}
		</div>
	) : null

export default React.memo(ModalNotification)
